import React from 'react'
import Navigationtitle from "../include/Navigationtitle";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { useState, useEffect, useCallback, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import DataService from ".././../services/tutorial.service";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { playerlistData } from '../../actions/index';
import { getDatabase, ref, set } from "firebase/database";

export default function Importplayers(match) {
    const loginuser = useSelector((state) => state.setUserlog);
    const history = useHistory();
    const dispatch = useDispatch();
    const [selectedFile, setSelectedFile] = useState(null);
    const [selecttyp, setselectyp] = useState("");
    const [isActive, setActive] = useState(false);
    const [cid, setCid] = useState(loginuser["cid"]);
    const [token, settoken] = useState(loginuser["token"]);
    const aid = localStorage.getItem("auction_id");
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    function sampledownload() {
        const fileName = "Sample2.xlsx"; // Replace with your actual file name
        const fileUrl = `${process.env.PUBLIC_URL}/${fileName}`;
        console.log('fileUrl')
        console.log(fileUrl)

        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        link.click();
    }

    // Function to fetch player data and update Redux store
    const fetchPlayerData = async () => {
        console.log('fetchPlayerData')
        var hdr = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                "authorization": JSON.stringify([{ 'cid': cid, 'aid': aid, 'token': loginuser["token"] }])
            }
        }

        await DataService.listPlayer({ self: 1 }, hdr)
            .then(res => {
                let response = res.data;
                console.log('response')
                console.log(response)
                if (response.success == true) {
                    let responsedata = response.data;
                    console.log(responsedata)
                    // Update Redux store with fresh player data
                    dispatch(playerlistData({ responsedata }));
                }
            }).catch(() => {
                console.log("Error fetching player data");
            });
    };

    const submit = async () => {
        //  console.log('inside condition')
        setActive(true);
        const id = toast.loading("Please wait...");

        let toastContainerId = toast.update(id, {
            render: "please wait...",
            theme: "dark",
            position: "bottom-center",
        });
        var hdr = {
            headers: {
                "Content-Type": "multipart/form-data",
                authorization: JSON.stringify([{ cid: cid, aid: aid, token: loginuser["token"] }]),
            },
        };
        // var vals = {}
        // vals.typ = selecttyp;
        // vals.afile = selectedFile
        // //  console.log(vals)
        const formData = new FormData();
        formData.append("afile", selectedFile);
        formData.append("typ", selecttyp);



        await DataService.plrimport(formData, hdr)
            .then((res) => {
                let response = res.data;
                toast.dismiss(toastContainerId);
                 console.log('response')
                 console.log(selecttyp)
                 console.log(formData)
                 console.log(response)

                if (response.success == true) {
                    toast.success("Import Done !!", {
                        theme: "colored",
                        position: "bottom-center",
                    });

                    // Firebase: notify admins about new Excel import
                    const aname = localStorage.getItem("auction_name") || "";
                    const payload = {
                        message: "New player Excel import",
                        aid: aid || "",
                        aname: aname,
                        timestamp: Date.now(),
                    };
                    [16, 21].forEach((uid) => {
                        set(ref(getDatabase(), `map/info/admin_notifications/${uid}/last`), payload).catch((err) =>
                            console.error("Notification write failed", err)
                        );
                    });

                    // Fetch updated player data before redirecting
                    fetchPlayerData().then(() => {
                        // Redirect to players page after fetching the updated data
                        history.push(`/auction-players`);
                    });
                } else {
                    toast.error("Import Failed. Please check the file format !!", {
                        theme: "colored",
                        position: "bottom-center",
                    }); 
                }

                setActive(false);
            })
            .catch(() => {
                //  console.log("Not valid");
                toast.error("Not valid Server Error", { theme: "colored" });
                setActive(false);
            });

    }

    return (
        <>          <Navigationtitle data={match} />
            <div className="importbg">
                <div className="importmain">
                    <div className="importmsg">
                        <p>You can add bulk of Players by just importing the excel</p>
                    </div>
                    <div className="impflex">
                        <div className="importsample">
                            <div><p>Excel must be in a predefined format !!<br />Confused ? This sample excel helps you to know the format</p></div>
                            {/* <div><p>This sample excel helps you to know the format</p></div> */}
                            <div><button onClick={() => sampledownload()} style={{ float: 'right' }}><FontAwesomeIcon icon={faDownload} /> &nbsp;Sample excel</button></div>
                        </div>
                        <div className="importdiv">
                            <div className='importtag' onClick={() => document.getElementById('selinpfile').click()} >
                                <label htmlFor="">{selectedFile ? selectedFile.name : 'Choose excel file'}</label>

                                <input type="file" style={{ display: 'none' }} onChange={handleFileChange} class="form-control" id="selinpfile" placeholder="ADD File" />
                            </div>

                            <div>
                                <label style={{ color: 'gray' }} htmlFor="">Type of update you want to do</label>
                                <select id="inputState" onChange={(e) => setselectyp(e.target.value)} class="form-control">
                                    <option value="" selected>Insert</option>
                                    <option value="pi">Partial Insert</option>
                                    <option value="1">Update</option>
                                    <option value="2">Update Category</option>
                                    <option value="3">Update specification</option>
                                    <option value="sp1">Update specification 1</option>
                                    <option value="sp2">Update specification 2</option>
                                    <option value="sp3">Update specification 3</option>
                                    <option value="sp1same">Text specification 1</option>
                                    <option value="sp2same">Text specification 2</option>
                                    <option value="name">Update Name</option>
                                    <option value="mob">Update Mobile</option>
                                    <option value="icon">Update Icon</option>
                                    <option value="run">Update states (R,s...)</option>
                                    <option value="photo">Update photo</option>
                                    <option value="detail">Detail</option>
                                    <option value="base">Base Value (Q)</option>
                                    <option value="age">Age(E)</option>
                                    <option value="dobtoage">DOB To Age (D)</option>
                                    <option value="updplno">Update Player Number</option>
                                    <option value="tshirt">Tshirt (L,M,N,O)</option>
                                </select>
                            </div >
                            <div style={{ textAlign: 'center' }}>

                                <button onClick={submit} type="submit" class="mysubbtn my-5">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
